<template>
  <div class="w-full">
    <div class="flex border-[#dcdfe5] border date-range">
      <div class="date-input flex items-center relative">
        <el-date-picker
          v-model="scheduleModel.startDate"
          type="date"
          format="DD MMM YY"
          value-format="YYYY-MM-DD"
          popper-class="playtime-datetime-picker"
          :clearable="false"
          :placeholder="$t('label.start')"
        />
        <div v-if="scheduleModel.startDate" class="clear-button cursor-pointer flex opacity-[0.3] hover:opacity-100" @click="resetValue('startDate')"><el-icon><CircleClose /></el-icon></div>
      </div>
      <span class="pt-[4px]">&mdash;</span>
      <div class="date-input flex items-center relative">
        <el-date-picker
          v-model="scheduleModel.endDate"
          class="no-icon"
          type="date"
          format="DD MMM YY"
          value-format="YYYY-MM-DD"
          prefix-icon=""
          popper-class="playtime-datetime-picker"
          :clearable="false"
          :disabled-date="disabledDate"
          :placeholder="$t('label.endDate')"
        />
        <div v-if="scheduleModel.endDate" class="clear-button cursor-pointer flex opacity-[0.3] hover:opacity-100" @click="resetValue('endDate')"><el-icon><CircleClose /></el-icon></div>
      </div>
    </div>
    <div
      v-if="showTimeRange"
      class="flex border-[#dcdfe5] border date-range time-range mt-[10px] relative">
      <el-icon :size="16" color="#000000" class="ml-[5px] mr-[6px]">
        <Clock />
      </el-icon>
      <el-radio-group
        class="m-[1px] time-format"
        v-model="selectedTimePickerFormat">
        <el-radio-button value="HH:mm" label="24H" />
        <el-radio-button value="hh:mm A" label="AM/PM" />
      </el-radio-group>
      <div class="time-input flex items-center relative">
        <el-time-picker
          v-model="scheduleModel.startTime"
          class="no-icon"
          popper-class="playtime-datetime-picker"
          :editable="true"
          :clearable="false"
          :format="selectedTimePickerFormat"
          :placeholder="$t('label.startTime')"
        />
        <div v-if="scheduleModel.startTime" class="clear-button cursor-pointer flex opacity-[0.3] hover:opacity-100" @click="resetValue('startTime')"><el-icon><CircleClose /></el-icon></div>
      </div>
      <span class="pt-[4px]">&mdash;</span>
      <div class="time-input flex items-center relative">
        <el-time-picker
          v-model="scheduleModel.endTime"
          class="no-icon"
          popper-class="playtime-datetime-picker"
          :editable="true"
          :clearable="false"
          :format="selectedTimePickerFormat"
          :placeholder="$t('label.endTime')"
        />
        <div v-if="scheduleModel.startTime" class="clear-button cursor-pointer flex opacity-[0.3] hover:opacity-100" @click="resetValue('endTime')"><el-icon><CircleClose /></el-icon></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useGlobalStore } from '@/pinia/stores/globalStore';

const globalStore = useGlobalStore()
const props = defineProps(['dateTimeValues', 'showTimeRange'])
const emit = defineEmits(['updateSchedule'])
const scheduleModel = ref(props.dateTimeValues)
const selectedTimePickerFormat = ref(globalStore.preferredTimeFormat)

function disabledDate (date) {
  const startDate = new Date(scheduleModel.value.startDate)
  startDate.setHours(0, 0, 0, 0)
  return date < startDate
}

function resetValue (key) {
  scheduleModel.value[key] = ''
}

watch(
  () => ({
    startDate: scheduleModel.value.startDate,
    endDate: scheduleModel.value.endDate,
    startTime: scheduleModel.value.startTime,
    endTime: scheduleModel.value.endTime,
  }),
  (newValues, oldValues) => {
    Object.keys(newValues).forEach((key) => {
      if (newValues[key] !== oldValues[key]) {
        emit('updateSchedule', key, newValues[key]);
      }
    });
  }
)

watch(selectedTimePickerFormat, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    globalStore.savePreferredTimeFormat(newValue)
  }
})
</script>
